import { createAction, props } from '@ngrx/store';
import { CaseDropdownsState } from '../reducers/dropdown.reducer';

export const loadAllDropdownData = createAction('[Dropdown] Load All Data');

export const loadAllDropdownDataSuccess = createAction(
  '[Dropdown] Load All Data Success',
  props<{ dropdowns: CaseDropdownsState }>()
);
